import axiosInstance from './axios';

export interface Rate {
    id: string;
    tipoVehiculo: string;
    tarifaBase: number;
    minutosGratis: number;
    fraccionMinutos: number;
    valorFraccion: number;
    tarifaMaximaDia: number;
    activo: boolean;
}

export interface CreateRateData {
    tipoVehiculo: string;
    tarifaBase: number;
    minutosGratis?: number;
    fraccionMinutos?: number;
    valorFraccion: number;
    tarifaMaximaDia?: number;
}

export const getRates = async (): Promise<Rate[]> => {
    const response = await axiosInstance.get<Rate[]>('/rates');
    return response.data;
};

export const createRate = async (data: CreateRateData): Promise<Rate> => {
    const response = await axiosInstance.post<Rate>('/rates', data);
    return response.data;
};

export const updateRate = async (id: string, data: Partial<CreateRateData>): Promise<Rate> => {
    const response = await axiosInstance.patch<Rate>(`/rates/${id}`, data);
    return response.data;
};

export const deleteRate = async (id: string): Promise<void> => {
    await axiosInstance.delete(`/rates/${id}`);
};
